/* eslint-disable operator-assignment */
/* eslint-disable max-len */
import PropTypes from 'prop-types';
import * as React from 'react';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';

import { useCallback, useState } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { getItemStyle } from '../../../../utils';
import { useTableDataContext } from '../../../context/EditingTableDataContext';
import { ActionsCell } from './ActionsCell';

export const ThirdLayer = ({
  firstLayerItemNum,
  firstLayerIndex,
  secondLayerItemNum,
  secondLayerIndex,
  thirdLayerItemNum,
  thirdLayerDescription,
  thirdLayerUnit,
  thirdLayerQuantity,
  thirdLayerUnitPrice,
  thirdLayerPrice,
  thirdLayerFinalized,
  thirdLayerIndex,
}) => {
  const { allTableDataWithExtraInfo, updateTableData, setToaster } =
    useTableDataContext();
  const [cellEditable, setCellEditable] = useState({
    description: '',
    unit: '',
    quantity: '',
    unitPrice: '',
    isFinalized: '',
  });

  React.useEffect(() => {
    setCellEditable({
      description: thirdLayerDescription,
      unit: thirdLayerUnit,
      quantity: thirdLayerQuantity,
      unitPrice: thirdLayerUnitPrice,
      isFinalized: thirdLayerFinalized,
    });
  }, [
    thirdLayerDescription,
    thirdLayerQuantity,
    thirdLayerUnit,
    thirdLayerUnitPrice,
    thirdLayerFinalized,
  ]);

  const updateTertiaryFieldHandler = (e) => {
    const newItems = [...allTableDataWithExtraInfo.items_attributes];
    const { name, value, checked } = e.target;

    let valueToFormat = value;

    if (name === 'unit_price') {
      const numericValue = value.replace(/\D/g, '').replace(',', '.');
      const floatValue = parseFloat(numericValue || 0) / 100;
      valueToFormat = floatValue;
    }

    if (name === 'quantity') {
      valueToFormat = value.replace(/[^0-9.,]/g, '');
    }

    newItems[firstLayerIndex].items_attributes[
      secondLayerIndex
    ].items_attributes[thirdLayerIndex][name] =
      name === 'is_finalized' ? checked : valueToFormat;

    const quantityTertiary =
      newItems[firstLayerIndex].items_attributes[secondLayerIndex]
        .items_attributes[thirdLayerIndex].quantity || '0';
    const unitPriceTertiary =
      newItems[firstLayerIndex].items_attributes[secondLayerIndex]
        .items_attributes[thirdLayerIndex].unit_price || 0;

    if (
      (name === 'quantity' || name === 'unit_price') &&
      (quantityTertiary !== '' ||
        quantityTertiary !== '0' ||
        quantityTertiary) &&
      unitPriceTertiary
    ) {
      const totalPrice = Number(quantityTertiary) * unitPriceTertiary;
      newItems[firstLayerIndex].items_attributes[
        secondLayerIndex
      ].items_attributes[thirdLayerIndex].price = totalPrice;

      let secondaryItemPrice = 0;
      newItems[firstLayerIndex].items_attributes[
        secondLayerIndex
      ].items_attributes.forEach((tertiaryItem) => {
        secondaryItemPrice += tertiaryItem.price || 0;
      });
      newItems[firstLayerIndex].items_attributes[secondLayerIndex].price =
        secondaryItemPrice;

      let primaryItemPrice = 0;
      newItems[firstLayerIndex].items_attributes.forEach((secondaryItem) => {
        primaryItemPrice += secondaryItem.price || 0;
      });
      newItems[firstLayerIndex].price = primaryItemPrice;
    }

    if (
      (name === 'quantity' || name === 'unit_price') &&
      (!quantityTertiary ||
        quantityTertiary === '0' ||
        quantityTertiary === '' ||
        !unitPriceTertiary)
    ) {
      newItems[firstLayerIndex].items_attributes[secondLayerIndex].price -=
        newItems[firstLayerIndex].items_attributes[
          secondLayerIndex
        ].items_attributes[thirdLayerIndex].price;

      let primaryItemPrice = 0;
      newItems[firstLayerIndex].items_attributes.forEach((secondaryItem) => {
        primaryItemPrice += secondaryItem.price || 0;
      });
      newItems[firstLayerIndex].price = primaryItemPrice;

      newItems[firstLayerIndex].items_attributes[
        secondLayerIndex
      ].items_attributes[thirdLayerIndex].price = '0';
    }

    updateTableData({
      ...allTableDataWithExtraInfo,
      items_attributes: newItems,
    });
  };

  const deleteRowFromCurrentLayer = useCallback(() => {
    const selectedItem =
      allTableDataWithExtraInfo.items_attributes[firstLayerIndex]
        .items_attributes[secondLayerIndex].items_attributes[thirdLayerIndex];

    if (selectedItem.has_payables) {
      setToaster({
        open: true,
        msg: 'Este item possui lançamentos associados e não pode ser excluído. Edite os lançamentos para remover a associação antes de excluir este item.',
      });
      setTimeout(() => setToaster({ open: false, msg: '' }), 5000);
    } else {
      const newArrayOfRows = allTableDataWithExtraInfo.items_attributes.map(
        (firstLayerItem, index) => {
          if (index === firstLayerIndex) {
            const updatedSecondLayerItems = firstLayerItem.items_attributes.map(
              (secondLayerItem, secondIndex) => {
                if (secondIndex === secondLayerIndex) {
                  const updatedThirdLayerItems =
                    secondLayerItem.items_attributes
                      .filter(
                        (_item, ThirdIndex) => ThirdIndex !== thirdLayerIndex
                      )
                      .map((item, idx) => ({
                        ...item,
                        item_num: `${idx + 1}`,
                      }));

                  let newSecondLayerPrice = 0;
                  updatedThirdLayerItems.forEach((item) => {
                    newSecondLayerPrice += item.price;
                  });
                  const formattedSecondLayerPrice = newSecondLayerPrice;

                  return {
                    ...secondLayerItem,
                    items_attributes: updatedThirdLayerItems,
                    price: formattedSecondLayerPrice,
                  };
                }
                return secondLayerItem;
              }
            );

            let newFirstLayerPrice = 0;
            updatedSecondLayerItems.forEach((item) => {
              newFirstLayerPrice += item.price;
            });
            const formattedFirstLayerPrice = newFirstLayerPrice;

            return {
              ...firstLayerItem,
              items_attributes: updatedSecondLayerItems,
              price: formattedFirstLayerPrice,
            };
          }
          return firstLayerItem;
        }
      );

      updateTableData({
        ...allTableDataWithExtraInfo,
        items_attributes: newArrayOfRows,
      });
    }
  }, [
    allTableDataWithExtraInfo,
    firstLayerIndex,
    secondLayerIndex,
    thirdLayerIndex,
    updateTableData,
  ]);

  const generateTableCell = ({ editable, align, data, id, propertyName }) => {
    if (id === 'is_finalized') {
      return (
        <TableCell align={align}>
          <Checkbox
            sx={{ m: 'auto' }}
            name={id}
            checked={data}
            onChange={(e) => {
              setCellEditable((prevState) => ({
                ...prevState,
                [propertyName]: e.target.checked,
              }));
              updateTertiaryFieldHandler(e);
            }}
            color="default"
          />
        </TableCell>
      );
    }

    return (
      <TableCell align={align}>
        {editable ? (
          <input
            name={id}
            style={{
              outline: 0,
              border: '0 none',
              fontFamily: 'montserrat',
              background: 'none',
              width: '100%',
              textAlign: align,
              fontSize: '12px',
            }}
            placeholder="Insira o dado"
            value={
              id === 'unit_price'
                ? data.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  })
                : data
            }
            onChange={(e) => {
              setCellEditable((prevState) => ({
                ...prevState,
                [propertyName]: e.target.value,
              }));
              updateTertiaryFieldHandler(e);
            }}
          />
        ) : (
          <span style={{ fontFamily: 'montserrat', fontSize: '12px' }}>
            {id === 'item_num'
              ? data
              : data.toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                })}
          </span>
        )}
      </TableCell>
    );
  };

  return (
    <Draggable
      index={thirdLayerIndex}
      draggableId={`${firstLayerItemNum}-${secondLayerItemNum}-${thirdLayerItemNum}`}
    >
      {/* eslint-disable-next-line no-shadow */}
      {(provided, snapshot) => (
        <TableRow
          className="tertiary-item"
          ref={provided.innerRef}
          {...provided.draggableProps}
          style={getItemStyle(
            snapshot.isDragging,
            provided.draggableProps.style
          )}
        >
          <TableCell align="left" />
          {generateTableCell({
            data: `${firstLayerItemNum}.${secondLayerItemNum}.${thirdLayerItemNum}`,
            align: 'left',
            id: 'item_num',
          })}
          {generateTableCell({
            data: cellEditable.description,
            align: 'left',
            editable: true,
            id: 'description',
            propertyName: 'description',
          })}
          {generateTableCell({
            data: cellEditable.unit,
            align: 'center',
            editable: true,
            id: 'unit',
            propertyName: 'unit',
          })}
          {generateTableCell({
            data: cellEditable.quantity,
            align: 'center',
            type: 'number',
            editable: true,
            id: 'quantity',
            propertyName: 'quantity',
          })}
          {generateTableCell({
            data: cellEditable.unitPrice,
            align: 'center',
            type: 'number',
            editable: true,
            id: 'unit_price',
            propertyName: 'unitPrice',
          })}
          {generateTableCell({
            data: thirdLayerPrice,
            align: 'center',
            id: 'price',
          })}
          {generateTableCell({
            data: cellEditable.isFinalized,
            align: 'center',
            id: 'is_finalized',
          })}
          <ActionsCell
            provided={provided}
            deleteRowFromCurrentLayer={deleteRowFromCurrentLayer}
            addNewItemSubLayerIconStyle={{
              // as it is the last layer, it does not need to show the icon for adding new items to sub-layers
              visibility: 'hidden',
            }}
            dragIconStyle={{
              cursor: 'inherit',
              width: '20px',
              marginTop: '6px',
            }}
            deleteIconStyle={{
              cursor: 'pointer',
              color: 'red',
            }}
            iconSize="small"
          />
        </TableRow>
      )}
    </Draggable>
  );
};

ThirdLayer.propTypes = {
  firstLayerItemNum: PropTypes.string.isRequired,
  firstLayerIndex: PropTypes.number.isRequired,
  secondLayerItemNum: PropTypes.string.isRequired,
  secondLayerIndex: PropTypes.number.isRequired,
  thirdLayerItemNum: PropTypes.string.isRequired,
  thirdLayerDescription: PropTypes.string.isRequired,
  thirdLayerUnit: PropTypes.string.isRequired,
  thirdLayerQuantity: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  thirdLayerUnitPrice: PropTypes.number.isRequired,
  thirdLayerPrice: PropTypes.number.isRequired,
  thirdLayerFinalized: PropTypes.bool.isRequired,
  thirdLayerIndex: PropTypes.number.isRequired,
};
